import { hmdaInfoSave } from "./_hmda_info_save";

export default {
  hmdaInfoSave
}
